import React from 'react';
import { Link } from 'react-router-dom';
import { useState, useEffect, useRef } from "react";
import { FaUpload } from "react-icons/fa";
import Select from "react-select";
import './styles/SubirContenido.css';
import { useForm, useFieldArray } from 'react-hook-form';
import { useSWRConfig } from "swr";
import Swal from 'sweetalert2';


//Temáticas disponibles
const tematicas = [
    {value: "Programación", label: "Programación"},
    {value: "Programación web", label: "Programación web"},
    {value: "Programación de aplicaciones móviles", label: "Programación de aplicaciones móviles"},
    {value: "Lenguajes de programación", label: "Lenguajes de programación"},
    {value: "Java", label: "Java"},
    {value: "C++", label: "C++"},
    {value: "Python", label: "Python"},
    {value: "JavaScript", label: "JavaScript"},
    {value: "Php", label: "Php"},
    {value: "IA", label: "IA"},
    {value: "Emprendimiento", label: "Emprendimiento"},
    {value: "Comunicación", label: "Comunicación"},
    {value: "Ventas", label: "Ventas"},
    {value: "Negocios", label: "Negocios"},
    {value: "Gestión de Proyectos", label: "Gestión de Proyectos"},
    {value: "Recursos Humanos", label: "Recursos Humanos"},
    {value: "Comercio electrónico", label: "Comercio electrónico"},
    {value: "Contabilidad", label: "Contabilidad"},
    {value: "Finanzas", label: "Finanzas"},
    {value: "Economía", label: "Economía"},
    {value: "Inversión", label: "Inversión"},
    {value: "Informática", label: "Informática"},
    {value: "Ofimática", label: "Ofimática"},
    {value: "Hardware", label: "Hardware"},
    {value: "Desarrollo Personal", label: "Desarrollo Personal"},
    {value: "Diseño", label: "Diseño"},
    {value: "Diseño Gráfico", label: "Diseño Gráfico"},
    {value: "Diseño 3D y animación", label: "Diseño 3D y animación"},
    {value: "Diseño de moda", label: "Diseño de moda"},
    {value: "Diseño arquitectónico", label: "Diseño arquitectónico"},
    {value: "Diseño de interiores", label: "Diseño de interiores"},
    {value: "Marketing", label: "Marketing"},
    {value: "Marketing digital", label: "Marketing digital"},
    {value: "Marca personal", label: "Marca personal"},
    {value: "Arte y manualidades", label: "Arte y manualidades"},
    {value: "Pintura", label: "Pintura"},
    {value: "Dibujo", label: "Dibujo"},
    {value: "Cocina", label: "Cocina"},
    {value: "Fotografía y vídeo", label: "Fotografía y vídeo"},
    {value: "Nutrición", label: "Nutrición"},
    {value: "Deporte y fitness", label: "Deporte y fitness"},
    {value: "Música", label: "Música"},
    {value: "Ingeniería", label: "Ingeniería"},
    {value: "Humanidades", label: "Humanidades"},
    {value: "Filosofía", label: "Filosofía"},
    {value: "Lengua y literatura", label: "Lengua y literatura"},
    {value: "Matemáticas", label: "Matemáticas"},
    {value: "Ciencia", label: "Ciencia"},
    {value: "Física", label: "Física"},
    {value: "Química", label: "Química"},
    {value: "Biología", label: "Biología"},
    {value: "Geología", label: "Geología"},
    {value: "Ciencias Sociales", label: "Ciencias Sociales"},
    {value: "Psicología", label: "Psicología"},
    {value: "Historia", label: "Historia"},
    {value: "Historia del arte", label: "Historia del arte"},
    {value: "Geografía", label: "Geografía"},
    {value: "Idiomas", label: "Idiomas"},
    {value: "Idioma Inglés", label: "Idioma Inglés"},
    {value: "Idioma Español", label: "Idioma Español"},
    {value: "Idioma Francés", label: "Idioma Francés"},
    {value: "Idioma Alemán", label: "Idioma Alemán"},
    {value: "Idioma Ruso", label: "Idioma Ruso"},
    {value: "Idioma Chino", label: "Idioma Chino"},
    {value: "Idioma Árabe", label: "Idioma Árabe"},
    {value: "Idioma Japonés", label: "Idioma Japonés"},
    {value: "Formación de profesorado", label: "Formación de profesorado"},
    {value: "Preparación para examenes oficiales", label: "Preparación para examenes oficiales"},
];

//Estilos del selector
const customStyles = {
    control: (provided, state) => ({
      ...provided,
      width: "100%", // Ancho completo
      height: "50px", // Altura fija
      background: 'transparent',
      border: '2px solid var(--border-color)',
      borderRadius: '40px',
      padding: '5px',
      boxShadow: state.isFocused ? '0 0 0 2px rgba(255, 255, 255, 0.5)' : 'none',
      fontSize: '16px',
      maxHeight: '70px', // Altura máxima del Select
      overflowY: 'auto', // Permite desplazamiento interno
      color: '#000',
      '&:hover': {
        borderColor: 'var(--border-color)',
      },
    }),
    singleValue: (provided) => ({
      ...provided,
      color: '#000', // Cambiar el color del texto
    }),
    input: (provided) => ({
      ...provided,
      color: '#000', // Color del texto mientras se escribe
    }),
    placeholder: (provided) => ({
      ...provided,
      color: 'var(--text-principal)', // Color del placeholder
    }),
    dropdownIndicator: (provided) => ({
        ...provided,
        color: 'var(--color-selectIcons)',        // color de la flecha
    }),
    clearIndicator: (provided) => ({
        ...provided,
        color: 'var(--color-selectIcons)',  
    }),
    multiValue: (provided) => ({
        ...provided,
        backgroundColor: 'var(--color-opcionseleccionada)', 
    }),
    multiValueLabel: (provided) => ({
        ...provided,
        color: 'var(--textButtonHome)',                                  
    }),
    menu: (provided) => ({
      ...provided,
      borderRadius: '10px',
      overflow: 'hidden',
    }),
    option: (provided, state) => ({
      ...provided,
      background: state.isFocused ? 'rgba(255, 255, 255, 0.2)' : 'transparent',
      color: '#000',
      '&:hover': {
        background: 'rgba(255, 255, 255, 0.3)',
      },
    }),
    ValueContainer: (provided) => ({
        ...provided,
        maxHeight: '10px', // Limita la altura del contenedor de valores seleccionados
        overflowY: 'auto', // Habilitar desplazamiento dentro del contenedor
    }),
};

let baseUrl;
if(process.env.NODE_ENV === 'development') baseUrl = 'http://localhost:8080';
else baseUrl='https://app-formacion.vercel.app';

const FormularioContenido = ({editando, datosIniciales, onClose, onSuccess}) => {
    const { mutate } = useSWRConfig();

    //Valores por defecto
    const { register, handleSubmit, control, watch, setValue, reset, formState: { errors }, clearErrors, setError } = useForm({
    defaultValues: {
      tipo: 'Curso',
      Tematica: [],         
      ImagenPortada: '',    
      Archivos: '',         
      numSesiones: 1,
      sesiones: [{ Parte: 1,  Nombre: '', URL: '', Fecha: '' }]
    }
});

//Manejar select
const [selectedOptions, setSelectedOptions] = useState([]);

//Manejar imagen Portada
const [imagen, setImagen] = useState(null);
const [nombreImagen, setNombreImagen] = useState("");
const fileInputRef = React.useRef(null);

//Manejar Archivos de curso
const [zipArchivo, setZipArchivo] = useState(null);
const [nombreZip, setNombreZip] = useState("");
const zipInputRef = useRef(null);



//Modo edición => Cuando llegue initialData establecemos valores de los campos
useEffect(() => {
    if(editando && datosIniciales){
        const tipoMapeado = datosIniciales.tipo === 'curso' ? 'Curso' : 'Clase';
        const parametrosFormulario = {
            tipo: tipoMapeado,

            Nombre: datosIniciales.Nombre || '',

            Tematica: Array.isArray(datosIniciales.Tematica) ? datosIniciales.Tematica : [],

            Descripcion: datosIniciales.Descripcion || '',

            Precio: datosIniciales.Precio ? datosIniciales.Precio.toString() : '',

            FechaInicio: datosIniciales.FechaInicio
                ? new Date(datosIniciales.FechaInicio).toISOString().split('T')[0]
                : '',

            FechaFin: datosIniciales.FechaFin
                ? new Date(datosIniciales.FechaFin).toISOString().split('T')[0]
                : '',

            Particular: Boolean(datosIniciales.Particular),

            Duracion: datosIniciales.Duracion || '',

            Plazas: datosIniciales.Plazas ? datosIniciales.Plazas.toString() : '',

            /*numSesiones: Array.isArray(datosIniciales.sesiones)
                ? datosIniciales.sesiones.length.toString()
                : '1',
            */

            // Para Archivos e ImagenPortada asumimos que vienen en base64 en el objeto
            ImagenPortada: datosIniciales.ImagenPortada || '',

            Archivos: datosIniciales.Archivos || '',

            /*sesiones: Array.isArray(datosIniciales.sesiones)
                ? datosIniciales.sesiones.map((s) => ({
                    Parte: s.Parte,
                    Nombre: s.Nombre,
                    URL: s.Enlace,
                    Fecha: s.Fecha
                        ? new Date(s.Fecha).toISOString().split('T')[0]
                        : '',
                    Duracion: s.Duracion,
                }))
                : [{ Parte: 1, Nombre: '', URL: '', Fecha: '', Duracion: '' }],*/
        };

        reset(parametrosFormulario);
            
        //Cargar el estado del select
        const opcionesSeleccionadas = tematicas.filter((t) => parametrosFormulario.Tematica.includes(t.value));
        setSelectedOptions(opcionesSeleccionadas);

        //Imagen/Zip 
        if(datosIniciales.ImagenPortada){
            setImagen(datosIniciales.ImagenPortada);
            setNombreImagen(`Imagen_${datosIniciales.Nombre}.png`);
        }
        if(datosIniciales.Archivos){
            setZipArchivo(datosIniciales.Archivos);
            setNombreZip(`Archivos_${datosIniciales.Nombre}.zip`)
        }
    }
}, [editando, datosIniciales, reset]);

//Sesiones y tipo de contenido
const tipo = watch('tipo');
const numSesiones = watch('numSesiones');
const { fields: sesiones, replace } = useFieldArray({ control, name: 'sesiones' });

//Establecer número de sesiones
useEffect(() => {
    if(!editando){
        const count = parseInt(numSesiones, 10) || 1;
        const items = Array.from({ length: count }, (_, i) => ({ Parte: i+1,  Nombre: '', URL: '', Fecha: '' }));
        replace(items);
    }
}, [numSesiones, replace, editando]);


//Manejar select
const handleSelect = (selected) => {
    setSelectedOptions(selected);
    setValue('Tematica', selected.map(o => o.value), { shouldValidate: true });
};


// Manejar el cambio de imagen de portada
const handleImageChange = (e) => {
    clearErrors("ImagenPortada");
    const file = e.target.files[0]; // Solo tomamos el primer archivo
    if (file) {
        const reader = new FileReader();
        setNombreImagen(file.name);
        reader.readAsDataURL(file); // Convertir imagen a Base64
        reader.onloadend = () => {
            const base64String = reader.result.split(',')[1]; // Extraer solo los datos base64

            setImagen(base64String); // Almacenamos el archivo en el estado
            setValue('ImagenPortada', base64String, { shouldValidate: true });
        };
    }
};

//Eliminar imagen seleccionada
const handleEliminarImagen = () => {
    setNombreImagen("");
    setImagen(null);
    if (fileInputRef.current) {
    fileInputRef.current.value = ""; // Restablece el input file
    }
};



const handleZipChange = e => {
    clearErrors("Archivos");
    const file = e.target.files[0];
    const extension = file?.name?.split('.').pop()?.toLowerCase();

    if (file && (file.type === 'application/zip' || extension === 'zip')) {
      const reader = new FileReader();
      setNombreZip(file.name);
      reader.readAsDataURL(file);
      reader.onloadend = () => {
        const base64String = reader.result.split(',')[1];;
        setZipArchivo(base64String);
        setValue('Archivos', base64String, { shouldValidate: true });

      };
    } else {
        Swal.fire({
            icon: 'warning',
            title: 'Archivo inválido',
            text: 'El archivo debe ser un ZIP',
            confirmButtonText: 'Aceptar'
        });
      e.target.value = null;
    }
};

//Eliminar el archivo zip
const handleEliminarArchivoZip = () => {
    setNombreZip("");
    setZipArchivo(null);
    zipInputRef.current && (zipInputRef.current.value = "");
};

//Si particular está marcado Plazas es 1
const particular = watch('Particular');

useEffect(() => {
if (particular) {
    setValue('Plazas', 1, { shouldValidate: true });
}
}, [particular, setValue]);

//Usuario logueado
const [usuario] = useState(() => {
        const usuarioAlmacenado = localStorage.getItem("userLogueado");
        return usuarioAlmacenado ? JSON.parse(usuarioAlmacenado) : null;
});

const onSubmit = async data => {

     let hayErrores = false;

    if (!imagen) {
        setError("ImagenPortada", { message: "Requerido" });
        hayErrores = true;
    }

    if (data.tipo === "Curso" && !zipArchivo) {
        setError("Archivos", { message: "Requerido" });
        hayErrores = true;
    }

    if (hayErrores){
        return; 
    }

    data.ImagenPortada = imagen;
    data.Archivos = zipArchivo
    data.id = usuario._id;

    if(editando){
        data.FechaSubida = datosIniciales.FechaSubida; 
        if(data.tipo === "Clase") data.ArrayIdSesiones = datosIniciales.Id_Sesion;
    }

    if (data.tipo === 'Clase') {
         data.sesiones = data.sesiones.map(s => ({
            Parte: s.Parte,
            Nombre: s.Nombre,
            Fecha: s.Fecha,
            Enlace: s.URL,
            Duracion: s.Duracion
        }));
    }


    const url = data.tipo === 'Curso'  ? `${baseUrl}/api/cursos` : `${baseUrl}/api/clases`
    const fetchUrl = editando ? `${url}/${datosIniciales._id}` : url
    const metodo = editando ? 'PUT' : 'POST';

    try {
        const resp = await fetch(fetchUrl, {
            method: metodo,
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(data)
        });
        if (!resp.ok) {
            throw new Error(`HTTP ${resp.status}`);
        }
        const result = await resp.json();

        console.log(editando ? 'Edicion OK' : 'Insercion OK', result);
        
        await Swal.fire({
            icon: 'success',
            title: '¡Éxito!',
            text: editando ? "Contenido modificado de forma exitosa" : 'Contenido creado de forma exitosa',
            confirmButtonText: 'OK'
        });

        await mutate([
            `${baseUrl}/api/cursos/`,
            `${baseUrl}/api/clases/`
        ]);

        //Actualizar caché
        if(editando) {
            await mutate(`${baseUrl}/api/productos/${datosIniciales._id}`);
            await mutate(`${baseUrl}/api/compras/search/usuario/${usuario?._id}`);
            await mutate(`${baseUrl}/api/users/tutor/${datosIniciales._id}`);
        }
        if(editando && onSuccess) onSuccess(result);
        else if(editando && onClose) onClose();
        else window.location.href = '/tutor';
    } catch (err) {
        console.error(editando ? 'Error al modificar el contenido' : 'Error al insertar:', err);
    }
};

const today = new Date().toISOString().split('T')[0];

const ahoraISO = new Date().toISOString();
const minFechaHora = ahoraISO.slice(0, 16);
const fechaFinOriginal = datosIniciales?.clase?.FechaFin?.split('T')[0];

    return (
        <div className='principalCont'>
            <div className='wrapperCont'>
                <form className='formularioContenido' onSubmit={handleSubmit(onSubmit)}>
                    {editando 
                        ? tipo === 'Curso' 
                            ? <h1>Editando curso</h1> 
                            : <h1>Editando clase</h1>
                        : tipo === 'Curso' 
                            ?  <h1>Creando curso</h1> 
                            : <h1>Creando clase</h1>
                    }
                    <div className='radio-grupo'>
                        <label>
                            <input type="radio" value="Curso" {...register('tipo')} checked={tipo === 'Curso'}  disabled={editando}/> Curso
                        </label>
                        <label>
                            <input type="radio" value="Clase" {...register('tipo')} checked={tipo === 'Clase'}  disabled={editando} /> Clase
                        </label>
                    </div>

                    <div>
                        <label>Nombre: </label>
                        <input type="text" {...register('Nombre', {required: "Requerido"})} />
                        {errors.Nombre && <span className='error'>{errors.Nombre.message}</span>}
                    </div>
                    <div>
                        <label>Temáticas del producto: </label>
                        <Select 
                            options={tematicas}
                            value={selectedOptions}
                            onChange={ (opts) => {
                                handleSelect(opts);
                                clearErrors('Tematica');
                            }}
                            isMulti={true}
                            styles={customStyles}
                            placeholder="Seleccione la temática"
                        />
                        <input type="hidden"{...register('Tematica', { required: 'Requerido' })} value={selectedOptions.map(o => o.value)}/>
                        {errors.Tematica && <span className='error'>{errors.Tematica.message}</span>}
                    </div>
                    <div>
                        <label>Descripción: </label>
                        <textarea {...register('Descripcion', { required: 'Requerido' })} />
                        {errors.Descripcion && <span className='error'>{errors.Descripcion.message}</span>} 
                    </div>
                    <div className='campo-enlinea'>
                        <label htmlFor="Precio">Precio: </label>
                        <input id="Precio" type="number" step="0.01" min="0" {...register('Precio', { required: 'Requerido', valueAsNumber: true, min: { value: 0, message: 'Debe ser ≥ 0'} })} /> €
                        {errors.Precio && <span className='error'>{errors.Precio.message}</span>} 
                    </div>
                    <div className='input-box-fileCont'>
                            <label className='input_label_fileCont'  htmlFor="imagen_file">Imagen de portada:</label>
                            <input type="file" id="imagen_file" accept="image/*" onChange={handleImageChange} ref={fileInputRef} hidden/>
                            <FaUpload className="icons" />

                        {nombreImagen && (
                        <div style={{  display: 'flex', alignItems: 'center' }}>
                            <p title={nombreImagen} style={{ color: 'var(--text-principal)', marginLeft: "10px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", marginTop: "10px" }}>
                                Archivo seleccionado: {nombreImagen}
                            </p>
                            <button
                                type="button"
                                onClick={handleEliminarImagen}
                                style={{
                                    background: "transparent",
                                    color: 'var(--text-principal)',
                                    border: "none",
                                    borderRadius: "5px",
                                    width: "10px",
                                    height: "10px",
                                    marginLeft: "10px",
                                    marginTop: "10px"
                                }}
                            >
                                X
                            </button>
                        </div>
                        )}
                        {errors.ImagenPortada && <span className='error' style={{display: 'block', marginTop: '30px'}}>{errors.ImagenPortada.message || 'Requerido'}</span>}
                    </div>

                    {tipo === 'Curso' && (
                        <>
                            <div className='campo-enlinea' style={{marginTop: '45px'}}>
                                <label htmlFor="duracion">Duración aproximada (en minutos): </label> 
                                <input id="duracion" type="number" min="0" {...register('Duracion', { required: 'Requerido', valueAsNumber: true, validate: v => Number.isInteger(v) || 'Debe ser un entero'})} /> minutos
                                {errors.Duracion && <span className='error'>{errors.Duracion.message}</span>}
                            </div>
                            <div className='input-box-fileCont'>
                                <label className='input_label_fileCont' htmlFor="zip_file">Subir archivo ZIP</label>
                                <input type="file" id="zip_file" accept="application/zip" onChange={handleZipChange} ref={zipInputRef} hidden/>
                                <FaUpload className="icons" />
                                
                                {nombreZip && (
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        <p title={nombreZip} style={{ color: 'var(--text-principal)', marginLeft: "10px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", marginTop: "10px" }}>Archivo Seleccionado: {nombreZip}</p>
                                        <button type="button" 
                                            onClick={handleEliminarArchivoZip}
                                            style={{
                                                background: "transparent",
                                                color: 'var(--text-principal)',
                                                border: "none",
                                                borderRadius: "5px",
                                                width: "10px",
                                                height: "10px",
                                                marginLeft: "10px",
                                                marginTop: "10px"
                                            }}
                                        >
                                            X
                                        </button>
                                    </div>
                                )}
                                {errors.Archivos && <span className='error' style={{ display: 'block', marginTop: '30px'}}>{errors.Archivos.message || 'Requerido'}</span>}
                            </div>
                        </>
                    )}

                    
                    {tipo === 'Clase' && (
                        <>
                            <div style={{marginTop: '45px'}}>
                                <label>Fecha de inicio: </label>
                                <input type="date"  min={editando ? undefined : today} {...register('FechaInicio', {required: 'Requerido', validate: v => editando || v >= today || 'No puede ser anterior a hoy'})} />
                                {errors.FechaInicio && <span className='error'>{errors.FechaInicio.message}</span>}
                            </div>
                            <div>
                                <label htmlFor="FechaFinalizacion">Fecha de finalización: </label>
                                <input type="date" id="FechaFinalizacion" min={editando ? undefined : watch('FechaInicio')} {...register('FechaFin', {required: 'Requerido',  validate: v => {
                                    const inicio = watch('FechaInicio');
                                    if (editando && v === fechaFinOriginal) return true;
                                    return v >= inicio || 'No puede ser anterior a Fecha de Inicio';}})}
                                />
                                {errors.FechaFin && <span className='error'>{errors.FechaFin.message}</span>}
                            </div>
                            <div className='checkboxParticular'>
                                <label htmlFor="Particular">Particular: </label>
                                <span>Sí</span>
                                <input  id="Particular" type="checkbox" {...register('Particular')} /> 
                            </div>
                            {!watch('Particular') && (
                                <div className='campo-enlinea'>
                                    <label>Plazas:</label>
                                    <input type="number" {...register('Plazas', { required: 'Requerido', valueAsNumber: true, validate: v => Number.isInteger(v) || 'Debe ser un entero'})} /> miembros
                                    {errors.Plazas && <span className='error'>{errors.Plazas.message}</span>}
                                </div>
                            )}
                            {!editando && (
                            <>
                                <div className='campo-enlinea'>
                                    <label>Número de sesiones:</label>
                                    <input type="number" min="1" {...register('numSesiones', { required: 'Requerido', valueAsNumber: true, validate: v => Number.isInteger(v) || 'Debe ser un entero' })} />
                                    {errors.numSesiones && <span className='error'>{errors.numSesiones.message}</span>}
                                </div>

                                {sesiones.map((sesion, index) => (
                                    <div key={sesion._id}>
                                        <h4>Sesión {index + 1}: </h4>
                                        <br/>
                                            <div className='campo-enlinea'>
                                                <label>Parte:</label>
                                                <input type="number" value={index + 1} readOnly {...register(`sesiones.${index}.Parte`)} />
                                            </div>
                                            <div>
                                                <label>Nombre de la sesión:</label>
                                                <input type="text" {...register(`sesiones.${index}.Nombre`, { required: 'Requerido' })} />
                                                {errors.sesiones?.[index]?.Nombre && <span className='error'>{errors.sesiones[index].Nombre.message}</span>}
                                            </div>
                                            <div style={{marginTop: '30px'}}>
                                                <label>URL:</label>
                                                <input type="url" {...register(`sesiones.${index}.URL`, { required: 'Requerido', validate: value => {
                                                    // Patrón para URLs de Google Meet: https://meet.google.com/xxx-xxxx-xxx
                                                    const meetRe = /^https:\/\/meet\.google\.com\/[a-z0-9]{3}-[a-z0-9]{4}-[a-z0-9]{3}$/i;

                                                    // Patrón para URLs de Zoom: https://us02web.zoom.us/j/1234567890 o cualquier subdominio
                                                    const zoomRe = /^https:\/\/(?:[a-z0-9-]+\.)?zoom\.us\/j\/\d+(?:\?[\w=&-]+)?$/;
                                                    if (meetRe.test(value) || zoomRe.test(value)) {
                                                        return true;
                                                    }
                                                    return 'Debido a politicas de la web solo se permiten URL de google meet o zoom';
                                                } })} />
                                                {errors.sesiones?.[index]?.URL && <span className='error'>{errors.sesiones?.[index].URL.message}</span>}
                                            </div>
                                            <div style={{marginTop: '30px'}}>
                                                <label>Fecha de la sesión: </label>
                                                <input type="datetime-local" min={minFechaHora} {...register(`sesiones.${index}.Fecha`, {required: 'Requerido', validate: v => {
                                                    const fechaS = new Date(v);
                                                    const inicio = new Date(watch('FechaInicio'))
                                                    const fin = new Date(watch('FechaFin'));
                                                    if (!watch('FechaInicio') || !watch('FechaFin')) return "Primero define rango de la clase";
                                                    if(fechaS < inicio) return "No puede ser anterior a Fecha de inicio de clase";
                                                    if(fechaS > fin) return "No puede ser posterior a Fecha de finalización de la clase"
                                                    return true;
                                                }})} />
                                                {errors.sesiones?.[index]?.Fecha && <span className='error'>{errors.sesiones?.[index].Fecha.message}</span>}
                                            </div>
                                            <div className='campo-enlinea' style={{marginTop: '30px'}}>
                                                <label htmlFor="duracionSesion">Duración de la sesión: </label>
                                                <input id="duracionSesion" type="number" min="0" {...register(`sesiones.${index}.Duracion`, {required: 'Requerido', valueAsNumber: true, validate: v => Number.isInteger(v) || 'Debe ser un entero'})} /> minutos
                                                {errors.sesiones?.[index]?.Duracion && <span className='error'>{errors.sesiones?.[index].Duracion.message}</span>}
                                            </div>
                                        </div>
                                    ))}
                                </>
                            )}
                        </>
                    )}

                    <button className='botonSubmit' type="submit">{editando ? 'Guardar cambios' : 'Subir contenido'}</button>
                </form>
            </div>
        </div>
    );
}

export default FormularioContenido;
